import { render, staticRenderFns } from "./seating_plan.vue?vue&type=template&id=6ea94cec&"
import script from "./seating_plan.vue?vue&type=script&lang=js&"
export * from "./seating_plan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports